// Cooperative yield that is NOT subject to Chrome's background-tab timer
// throttling. setTimeout(0) in a backgrounded tab is clamped to ≥1s (up to a
// minute under intensive throttling), which would stall simulation tabs running
// in parallel; a MessageChannel task runs at full speed regardless of focus.

const channel = new MessageChannel();

let pending: ( () => void ) | null = null;

channel.port1.onmessage = () =>
{
  const resolve = pending;
  pending = null;
  resolve?.();
};

/** Lets the browser process events, then continues — background-tab safe. */
export function yieldToBrowser(): Promise<void>
{
  return new Promise( resolve =>
  {
    pending = resolve;
    channel.port2.postMessage( null );
  } );
}
